import axios from 'axios'
import {LoginResponse} from '../types/hooks/auth'

const { REACT_APP_MASTERDATAS_API_URL } = process.env

export interface Currency {
    id: string
    currency_id: string
    currency_name: string
  
 
}

const handleResponseError = (error: any) => {
    //? = protect data no value
    if(error?.response?.data?.error){
        throw error.response.data.error
    }
    throw error
}

export const requestCurrencys = async(conditions: object = {},accessToken: string): Promise<Currency[]> => {
    const data:Currency[] = await axios
    .get(`${REACT_APP_MASTERDATAS_API_URL}/currencys/all?access_token=${accessToken}`,{
        // headers: {
        //     Authorization: `Bearer ${accessToken}`
        // }
    })
    .then(response => response.data)
    .catch(error => handleResponseError(error))

    return data
}

